import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { useCallback, useEffect, useMemo, useTransition } from 'react';
import { useSearchParams } from 'react-router';
import { companyCaptablesByIdStateJ } from '../../../services/state/CapTableDataStateJ';
import { useResetCapTableFormStateJ } from '../../../services/state/CapTableFormStateJ';
import { selectedCompanyIdProfileAtom } from '../state/UIStateJ';
import { useSetCaptableFormState } from './CapTableActions';

export const CaptableIdParam = 'captableId';

export function useSyncCaptableFormFromPath() {
  const [isPending, startTransition] = useTransition();
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const [search] = useSearchParams();
  const captableId = parseInt(search.get(CaptableIdParam) ?? '-1');
  const setFormState = useSetCaptableFormState();
  const captableMapAtom = useMemo(
    () => unwrap(companyCaptablesByIdStateJ(companyId), () => undefined),
    [companyId]
  );
  const captableMap = useAtomValue(captableMapAtom);

  const syncForm = useCallback(() => {
    if (!captableMap) {
      return;
    }
    const captable = captableMap.get(captableId);
    if (!captable || captable.companyId !== companyId) {
      return;
    }
    setFormState(captable);
  }, [captableId, captableMap, companyId, setFormState]);

  useEffect(() => {
    startTransition(syncForm);
  }, [syncForm]);

  const resetState = useResetCapTableFormStateJ();

  useEffect(() => {
    return resetState;
  }, [resetState]);

  return !isPending;
}
